import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 12 20",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n        .drag-icon-st0{fill:currentColor;}\n    "
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 0,
			y: 0,
			width: 4,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 8,
			y: 0,
			width: 4,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 0,
			y: 8,
			width: 4,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 8,
			y: 8,
			width: 4,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 0,
			y: 16,
			width: 4,
			height: 4
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "drag-icon-st0",
			x: 8,
			y: 16,
			width: 4,
			height: 4
		})
	]
});
export default SvgDragIcon;
